<div *ngIf="mediationContractForm && isProperty" [formGroup]="mediationContractForm" class="row mt-n4">
  <div class="card">
    <!-- <div class="card-header">
      <h5 class="card-title mb-0">{{ 't-m-properties.t-mediation-agreement' | translate }}</h5>
    </div> -->

    <div class="card-body">
      <div class="row">
        <div class="col-lg-4">
          <div class="mb-3">
            <label for="startdateInput" class="form-label">
              {{'t-contract-number' | translate}}
            </label>

            <input class="form-control flatpickr-input" type="text" placeholder="{{ 't-contract-number' | translate }}"
              formControlName="contractNumber">
          </div>
        </div>

        <div class="col-lg-4">
          <div class="mb-3">
            <label for="startdateInput" class="form-label">
              {{ 't-m-properties.t-start-date' | translate }}
            </label>

            <input class="form-control flatpickr-input" type="text"
              (flatpickrChange)="endStartDateChange('start', $event)"
              placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-start-date' | translate }}"
              mwlFlatpickr [convertModelValue]="false" [monthSelectorType]="'static'" [dateFormat]="'Y-m-d'"
              formControlName="startDateMediation" (change)="onChangeStartDateMediation($event)" #inputRefp>
          </div>
        </div>
        <!--end col-->

        <div class="col-lg-4">
          <div class="mb-3">
            <label for="enddateInput" class="form-label">
              {{ 't-m-properties.t-end-date' | translate }}
            </label>

            <input class="form-control flatpickr-input" type="text"
              (flatpickrChange)="endStartDateChange('end', $event)"
              placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-end-date' | translate }}"
              mwlFlatpickr [convertModelValue]="false" [dateFormat]="'Y-m-d'" formControlName="endDateMediation"
              id="endDateMediation" [disabled]="this.mediationContractForm.get('defineEndDate')?.value > 0"
              [attr.style]="this.mediationContractForm.get('defineEndDate')?.value > 0 ? 'background-color:#eff2f7;cursor: auto;' : null"
              #inputRefp>
          </div>
        </div>
        <!--end col-->

        <div class="col-lg-4">
          <div class="mb-3">
            <label for="defEnddateInput" class="form-label">
              {{ 't-m-properties.t-define-end-date' | translate }}
            </label>

            <ng-select [items]="[3,6,12,24,36]" [multiple]="false" bindLabel="name"
              (change)="onChangeDefineDate($event)" bindValue="id" placeholder="{{ 't-general.t-select' | translate }}"
              formControlName="defineEndDate"></ng-select>
          </div>
        </div>

        <div *ngIf="false" class="col-lg-4 d-flex align-items-center mt-3 gap-2">
          <div class="form-check mb-0">
            <input class="form-check-input mb-2" type="checkbox" id="autoRenewal" formControlName="autoRenewal" />

            <label class="form-check-label" for="autoRenewal">

              {{ 't-m-properties.t-auto-renewal' | translate }}
            </label>
          </div>
        </div>

        <!--end col-->

        <!-- <div class="d-flex justify-content-end mb-3">
          <button type="button" class="btn btn-outline-primary waves-effect waves-light text-center"
            (click)="openModal()">
            {{ 't-preview' | translate }}
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <!-- end card -->
</div>

<ng-template #mediationContractModal class="modal" let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="mediationContractModalLabel">
      {{ "t-m-properties.t-mediation-agreement"| translate}}
    </h5>

    <button type="button" (click)="modal.dismiss()" class="btn-close" data-bs-dismiss="modal"
      aria-label="Fechar"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="mediationContractForm" class="mediation-contract-form">
      <div class="accordion" id="mediationContractAccordion">
        <!-- Accordion Item: Contrato -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingIntro">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseIntro"
              aria-expanded="true" aria-controls="collapseIntro" [ngClass]="{'text-danger':mediationContractForm.get('contractNumber')?.invalid ||
                  mediationContractForm.get('entityName')?.invalid ||
                  mediationContractForm.get('entityAddress')?.invalid ||
                  mediationContractForm.get('entityCapital')?.invalid ||
                  mediationContractForm.get('entityFiscalIdentification')?.invalid ||
                  mediationContractForm.get('conservatory')?.invalid ||
                  mediationContractForm.get('conservatoryNumber')?.invalid ||
                  mediationContractForm.get('licenseImo')?.invalid ||
                  mediationContractForm.get('ownerName')?.invalid ||
                  mediationContractForm.get('address')?.invalid ||
                  mediationContractForm.get('city')?.invalid ||
                  mediationContractForm.get('ownerIdentification')?.invalid ||
                  mediationContractForm.get('ownerFiscalIdentification')?.invalid ||
                  mediationContractForm.get('ownerRole')?.invalid}">
              Contrato
              <span *ngIf="
                mediationContractForm.get('contractNumber')?.invalid ||
                mediationContractForm.get('entityName')?.invalid ||
                mediationContractForm.get('entityAddress')?.invalid ||
                mediationContractForm.get('entityCapital')?.invalid ||
                mediationContractForm.get('entityFiscalIdentification')?.invalid ||
                mediationContractForm.get('conservatory')?.invalid ||
                mediationContractForm.get('conservatoryNumber')?.invalid ||
                mediationContractForm.get('licenseImo')?.invalid ||
                mediationContractForm.get('ownerName')?.invalid ||
                mediationContractForm.get('address')?.invalid ||
                mediationContractForm.get('city')?.invalid ||
                mediationContractForm.get('ownerIdentification')?.invalid ||
                mediationContractForm.get('ownerFiscalIdentification')?.invalid ||
                mediationContractForm.get('ownerRole')?.invalid" class="badge bg-danger ms-2">
                Campos Obrigatórios
              </span>
            </button>
          </h2>

          <div id="collapseIntro" class="accordion-collapse collapse show" aria-labelledby="headingIntro"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <div> {{ "t-contract-number" | translate }}
                <input id="contractNumber" formControlName="contractNumber" name="contractNumber" type="text"
                  class="form-control d-inline-block" style="width: 150px;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('contractNumber')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('contractNumber')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
              </div>

              <div>
                Entre <input id="entityName" formControlName="entityName" placeholder="Nome da Imobiliária"
                  name="entityName" type="text" class="form-control" style="width: 70%;display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('entityName')?.invalid }">
                <div *ngIf="mediationContractForm.get('entityName')?.invalid" class="invalid-feedback d-block">
                  Campo obrigatório.
                </div>
                , com sede social na
                <input id="entityAddress" formControlName="entityAddress" placeholder="Morada da Imobiliária"
                  name="entityAddress" type="text" class="form-control" style="width: 100%; display: inline-block;"
                  required [ngClass]="{'is-invalid': mediationContractForm.get('entityAddress')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('entityAddress')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                , com o
                capital social de <input id="entityCapital" formControlName="entityCapital" placeholder="Capital Social"
                  name="entityCapital" type="text" class="form-control" style="width: 150px; display: inline-block;"
                  required [ngClass]="{'is-invalid': mediationContractForm.get('entityCapital')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('entityCapital')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                Euros, e
                com o NIPC n.º <input id="entityFiscalIdentification" formControlName="entityFiscalIdentification"
                  placeholder="NIPC" name="entityFiscalIdentification" type="text" class="form-control"
                  style="width: 110px;display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('entityFiscalIdentification')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('entityFiscalIdentification')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                matriculada na Conservatória do Registo Comercial de <input id="conservatory"
                  formControlName="conservatory" placeholder="Local" name="conservatory" type="text"
                  class="form-control" style="width: 200px;display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('conservatory')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('conservatory')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                sob o nº
                <input id="conservatoryNumber" formControlName="conservatoryNumber" placeholder="Número"
                  name="conservatoryNumber" type="text" class="form-control" style="width: 100px;display: inline-block;"
                  required [ngClass]="{'is-invalid': mediationContractForm.get('conservatoryNumber')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('conservatoryNumber')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                , detentora da licença
                AMI nº <input id="licenseImo" formControlName="licenseImo" placeholder="AMI" name="licenseImo"
                  type="text" class="form-control" style="width: 100px;display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('licenseImo')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('licenseImo')?.invalid" class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                , emitida
                pelo Instituto dos
                Mercados Públicos, do Imobiliário e da
                Construção I.P. (IMPIC, I.P.),
                adiante designada como Mediadora,
              </div>

              <div>
                E
                <input id="ownerName" formControlName="ownerName"
                  placeholder="Nome do cliente pessoa singular ou coletiva" name="ownerName" type="text"
                  class="form-control" style="width: 70%;display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('ownerName')?.invalid }">
                <!-- <div *ngIf="mediationContractForm.get('ownerName')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                ,
                <ng-select [items]="[{label: 'Solteiro(a)', value: 'SINGLE'},
                {label: 'Casado(a)', value: 'MARRIED'},
                {label: 'Divorciado(a)', value: 'DIVORCED'},
                {label: 'Viúvo(a)', value: 'WIDOWED'},
                 {label: 'Separado(a)', value: 'SEPARATED'}]" bindLabel="label" bindValue="value"
                  formControlName="maritalStatus" placeholder="Estado civil" [clearable]="false" class="d-inline-block"
                  style="width: 150px;">
                </ng-select>
                sob o regime de bens
                <ng-select [items]="[
                { label: 'Comunhão de adquiridos', value: 'COMMUNION_ACQUIRED' },
                { label: 'Comunhão geral', value: 'COMMUNION_GENERAL' },
                { label: 'Separação de bens', value: 'SEPARATION' },
                { label: 'Outro', value: 'OTHER' }]" bindLabel="label" bindValue="value"
                  formControlName="propertyRegime" placeholder="Regime de bens" [clearable]="false"
                  class="d-inline-block" style="width: 180px;">
                </ng-select>
                , com
                <input id="spouse" formControlName="spouse" placeholder="Nome do cônjuge (se aplicável)" name="spouse"
                  type="text" class="form-control" style="width: 55%;display: inline-block;">
                ,
                residente(s) na
                <input id="address" formControlName="address" placeholder="Morada" name="address" type="text"
                  class="form-control" style="width: 60%;display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('address')?.invalid}">
                <!-- <div *ngIf="mediationContractForm.get('address')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                em
                <input id="city" formControlName="city" placeholder="Localidade" name="city" type="text"
                  class="form-control" style="width: 150px; display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('city')?.invalid}">
                <!-- <div *ngIf="mediationContractForm.get('city')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                portador (es) do (s) C.C./B.I. nºs
                <input id="ownerIdentification" formControlName="ownerIdentification" name="ownerIdentification"
                  type="text" class="form-control" style="width: 120px; display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('ownerIdentification')?.invalid}">
                <!-- <div *ngIf="mediationContractForm.get('ownerIdentification')?.invalid" class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                e
                <input id="ownerIdentification2" formControlName="ownerIdentification2" name="ownerIdentification2"
                  type="text" class="form-control" style="width: 120px; display: inline-block;">
                e contribuinte (s) fiscal (is) nºs
                <input id="ownerFiscalIdentification" formControlName="ownerFiscalIdentification"
                  name="ownerFiscalIdentification" type="text" class="form-control"
                  style="width: 120px; display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('ownerFiscalIdentification')?.invalid}">
                <!-- <div *ngIf="mediationContractForm.get('ownerFiscalIdentification')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                e
                <input id="ownerFiscalIdentification2" formControlName="ownerFiscalIdentification2"
                  name="ownerFiscalIdentification2" type="text" class="form-control"
                  style="width: 120px; display: inline-block;">
                , com o contacto telefónico
                <input id="phone" formControlName="phone" name="phone" type="text" class="form-control"
                  style="width: 150px; display: inline-block;">
                e endereço electrónico
                <input id="email" formControlName="email" name="email" type="email" class="form-control"
                  style="width: 200px; display: inline-block;">
                aqui representada pelo seu sócio gerente / administrador / procurador / gestor de
                negócios com poderes para o ato,
                com domicílio profissional na sede da sua representada, adiante designado (s)
                como Segundo (s) Contratante (s) na qualidade de
                <select id="ownerRole" formControlName="ownerRole" name="ownerRole" class="form-control"
                  style="width: 200px; display: inline-block;" required
                  [ngClass]="{'is-invalid': mediationContractForm.get('ownerRole')?.invalid}">
                  <option value="OWNER">Proprietário</option>
                  <option value="LANDLORD">Senhorio</option>
                  <option value="PIERCING">Trespassante</option>
                  <option value="OTHER">Outro</option>
                </select>
                <!-- <div *ngIf="mediationContractForm.get('ownerRole')?.invalid"
                                    class="invalid-feedback d-block">
                                    Campo obrigatório.
                                </div> -->
                , é celebrado o presente Contrato de Mediação Imobiliária que se rege pelas
                seguintes cláusulas:
              </div>
            </div>
          </div>
        </div>

        <!-- Accordion Item: Cláusula 1ª - Identificação do Imóvel -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausulas">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausulas" aria-expanded="false" aria-controls="collapseClausulas" [ngClass]="{'text-danger':mediationContractForm.get('propertyType')?.invalid|| 
              mediationContractForm.get('divisions')?.invalid ||
              mediationContractForm.get('area')?.invalid ||
              mediationContractForm.get('propertyAddress')?.invalid ||
              mediationContractForm.get('propertyCity')?.invalid ||
              mediationContractForm.get('parish')?.invalid ||
              mediationContractForm.get('county')?.invalid}">
              Cláusula 1ª - Identificação do Imóvel
              <span *ngIf="mediationContractForm.get('propertyType')?.invalid ||
              mediationContractForm.get('divisions')?.invalid ||
              mediationContractForm.get('area')?.invalid ||
              mediationContractForm.get('propertyAddress')?.invalid ||
              mediationContractForm.get('propertyCity')?.invalid ||
              mediationContractForm.get('parish')?.invalid ||
              mediationContractForm.get('county')?.invalid" class="badge bg-danger ms-2">
                Campos Obrigatórios
              </span>
            </button>
          </h2>

          <div id="collapseClausulas" class="accordion-collapse collapse" aria-labelledby="headingClausulas"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              O Segundo Contratante é proprietário e legítimo possuidor da fração autónoma/prédio
              (rústico/urbano)/estabelecimento comercial, destinado(a)
              a
              <input id="propertyType" formControlName="propertyType" name="propertyType" type="text"
                class="form-control" style="width: 180px; display: inline-block;"
                [ngClass]="{'is-invalid': mediationContractForm.get('propertyType')?.invalid }">
              <!-- <div *ngIf="mediationContractForm.get('propertyType')?.invalid"
                                class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              , sendo constituído
              por <input id="divisions" formControlName="divisions" name="divisions" type="text" class="form-control"
                style="width: 60px; display: inline-block;"
                [ngClass]="{'is-invalid': mediationContractForm.get('divisions')?.invalid }">
              <!-- <div *ngIf="mediationContractForm.get('divisions')?.invalid"
                                class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              divisões, com uma área
              total de <input id="area" formControlName="area" name="area" type="text" class="form-control"
                style="width: 80px; display: inline-block;"
                [ngClass]="{'is-invalid': mediationContractForm.get('area')?.invalid }">
              <!-- <div *ngIf="mediationContractForm.get('area')?.invalid" class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              m², sito na <input id="propertyAddress" formControlName="propertyAddress" name="propertyAddress"
                type="text" class="form-control" style="width: 350px; display: inline-block;"
                [ngClass]="{'is-invalid': mediationContractForm.get('propertyAddress')?.invalid }">
              <!-- <div *ngIf="mediationContractForm.get('propertyAddress')?.invalid"
                                class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              ,
              em <input id="propertyCity" formControlName="propertyCity" name="propertyCity" type="text"
                class="form-control" style="width: 180px; display: inline-block;"
                [ngClass]="{'is-invalid': mediationContractForm.get('propertyCity')?.invalid }">
              <!-- <div *ngIf="mediationContractForm.get('propertyCity')?.invalid"
                                class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              <input id="parish" formControlName="parish" placeholder="Freguesia" name="parish" type="text"
                class="form-control" style="width: 180px; display: inline-block;"
                [ngClass]="{'is-invalid': mediationContractForm.get('parish')?.invalid }">
              <!-- <div *ngIf="mediationContractForm.get('parish')?.invalid" class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              , <input id="county" formControlName="county" placeholder="Concelho" name="county" type="text"
                class="form-control" style="width: 180px; display: inline-block;"
                [ngClass]="{'is-invalid': mediationContractForm.get('county')?.invalid }">
              <!-- <div *ngIf="mediationContractForm.get('county')?.invalid" class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              ,
              descrito na Conservatória do Registo Predial
              de <input id="registryOffice" formControlName="registryOffice" name="registryOffice" type="text"
                class="form-control" style="width: 220px; display: inline-block;">
              , sob a
              ficha nº <input id="registryNumber" formControlName="registryNumber" name="registryNumber" type="text"
                class="form-control" style="width: 100px; display: inline-block;">, com a
              licença de construção/utilização
              nº <input id="constructionLicense" formControlName="constructionLicense" name="constructionLicense"
                type="text" class="form-control" style="width: 120px; display: inline-block;">
              emitida pela Câmara Municipal de
              <input id="cityCouncil" formControlName="cityCouncil" name="cityCouncil" type="text" class="form-control"
                style="width: 250px; display: inline-block;">
              em
              <input id="issueDate" formControlName="issueDate" name="issueDate" type="date" class="form-control"
                style="width: 170px; display: inline-block;">
              e inscrito na matriz predial (urbana/rústica)
              com o artigo nº
              <input id="matrixArticle" formControlName="matrixArticle" name="matrixArticle" type="text"
                class="form-control" style="width: 120px; display: inline-block;">
              da freguesia de
              <input id="matrixParish" formControlName="matrixParish" name="matrixParish" type="text"
                class="form-control" style="width: 200px; display: inline-block;">
              /omisso na matriz
              <input id="matrixOmitted" formControlName="matrixOmitted" name="matrixOmitted" type="text"
                class="form-control" style="width: 200px; display: inline-block;">
            </div>
          </div>
        </div>

        <!-- Cláusula 2ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula2" aria-expanded="false" aria-controls="collapseClausula2">
              Cláusula 2ª - Identificação do Negócio
            </button>
          </h2>

          <div id="collapseClausula2" class="accordion-collapse collapse" aria-labelledby="headingClausula2"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <div class="mb-2">
                <label class="form-label me-2">1 - A Mediadora obriga-se a diligenciar no sentido de
                  conseguir
                  interessado na:</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="businessBuy" formControlName="businessBuy"
                    name="businessBuy" value="Compra">
                  <label class="form-check-label" for="businessBuy">Compra</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="businessTransfer"
                    formControlName="businessTransfer" name="businessTransfer" value="Trespasse">
                  <label class="form-check-label" for="businessTransfer">Trespasse</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="businessRent" formControlName="businessRent"
                    name="businessRent" value="Arrendamento">
                  <label class="form-check-label" for="businessRent">Arrendamento</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="businessOther" formControlName="businessOther"
                    name="businessOther" value="Outro">
                  <label class="form-check-label" for="businessOther">Outro</label>
                </div>
                <input *ngIf="form['businessOther'].value" type="text" class="form-control mt-2"
                  id="businessOtherDescription" formControlName="businessOtherDescription"
                  name="businessOtherDescription" placeholder="Descreva outro negócio">
              </div>
              <div class="mb-2">
                <label class="form-label">Preço de Euros</label>
                <input type="text" class="form-control" id="businessPrice" formControlName="businessPrice"
                  name="businessPrice" placeholder="Valor em Euros">
                <input type="text" class="form-control mt-2" id="businessPriceWritten"
                  formControlName="businessPriceWritten" name="businessPriceWritten" placeholder="Valor por extenso">
              </div>
              <div class="mb-2">
                <label class="form-label">2 - Qualquer alteração ao preço fixado deverá ser comunicada
                  de
                  imediato e por escrito à Mediadora.</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Cláusula 3ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula3" aria-expanded="false" aria-controls="collapseClausula3">
              Cláusula 3ª - Ónus e Encargos
            </button>
          </h2>
          <div id="collapseClausula3" class="accordion-collapse collapse" aria-labelledby="headingClausula3"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="onus" id="onusFree" formControlName="onus"
                  [value]="false">
                <label class="form-check-label" for="onusFree">
                  O imóvel encontra-se livre de quaisquer ónus ou encargos.
                </label>
              </div>
              <div class="form-check mb-2">
                <input class="form-check-input" type="radio" name="onus" id="onusWith" formControlName="onus"
                  [value]="true">
                <label class="form-check-label" for="onusWith">
                  O Segundo Contratante declara que sobre o imóvel recaem os seguintes ónus e encargos
                  (hipotecas e penhoras):
                </label>
              </div>
              <input *ngIf="form['onus'].value" type="text" class="form-control mb-2" id="onusDescription"
                formControlName="onusDescription" name="onusDescription" placeholder="Descreva os ónus e encargos">
              <input *ngIf="form['onus'].value" type="text" class="form-control" id="onusValue"
                formControlName="onusValue" name="onusValue" placeholder="Valor em Euros">
            </div>
          </div>
        </div>

        <!-- Cláusula 4ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula4" aria-expanded="false" aria-controls="collapseClausula4">
              Cláusula 4ª - Regime de Contratação
            </button>
          </h2>
          <div id="collapseClausula4" class="accordion-collapse collapse" aria-labelledby="headingClausula4"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <div class="mb-2">
                <label class="form-label me-2">1 - O Segundo Contratante contrata a Mediadora em regime
                  de:</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="contractRegime" id="exclusivity"
                    formControlName="contractRegime" [value]="true">
                  <label class="form-check-label" for="exclusivity">Exclusividade</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="contractRegime" id="noExclusivity"
                    formControlName="contractRegime" [value]="false">
                  <label class="form-check-label" for="noExclusivity">Não Exclusividade</label>
                </div>
              </div>
              <div>
                <span>
                  2 - Nos termos da legislação aplicável, quando o contrato é celebrado em regime de
                  exclusividade só a Mediadora contratada tem o direito de promover o negócio objeto
                  do contrato de mediação durante o respetivo período de vigência, ficando o Segundo
                  Contratante obrigado a pagar a comissão acordada caso viole a obrigação de
                  exclusividade.
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Cláusula 5ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula5" aria-expanded="false" aria-controls="collapseClausula5">
              Cláusula 5ª - Remuneração
            </button>
          </h2>

          <div id="collapseClausula5" class="accordion-collapse collapse" aria-labelledby="headingClausula5"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <ol>
                <li>
                  A remuneração será devida se a Mediadora conseguir interessado que concretize o
                  negócio visado pelo presente contrato e também, nos casos em que o contrato tenha
                  sido celebrado em regime de exclusividade, o negócio não se concretize por causa
                  imputável ao cliente.
                </li>
                <li>
                  O Segundo Contratante obriga-se a pagar à Mediadora a título de remuneração:
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="remunerationType" id="remunerationPercentMin"
                      formControlName="remunerationType" value="PercentualMinimo">
                    <label class="form-check-label" for="remunerationPercentMin">
                      A quantia de
                      <input type="text" mask="separator" suffix="%" class="form-control d-inline-block"
                        style="width: 80px;" id="percentMin" formControlName="percentMin" name="percentMin"
                        placeholder="%">
                      calculada sobre o preço pelo qual o negócio é efetivamente concretizado, com
                      o valor mínimo de
                      <input type="text" class="form-control d-inline-block" style="width: 100px;" id="minValue"
                        formControlName="minValue" name="minValue" placeholder="€">
                      , acrescido de IVA à taxa legal de
                      <input type="text" mask="separator" suffix="%" class="form-control d-inline-block"
                        style="width: 60px;" id="taxMin" formControlName="taxMin" name="taxMin" placeholder="%">
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="remunerationType" id="remunerationPercent"
                      formControlName="remunerationType" value="Percentual">
                    <label class="form-check-label" for="remunerationPercent">
                      A quantia de
                      <input type="text" mask="separator" suffix="%" class="form-control d-inline-block"
                        style="width: 80px;" id="percent" formControlName="percent" name="percent" placeholder="%">
                      sobre o preço pelo qual o negócio é efetivamente concretizado, acrescido de
                      IVA à taxa legal de
                      <input type="text" mask="separator" suffix="%" class="form-control d-inline-block"
                        style="width: 60px;" id="tax" formControlName="tax" name="tax" placeholder="%">
                    </label>
                  </div>
                </li>
                <li>
                  O pagamento da remuneração apenas será efetuado nas seguintes condições:
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="paymentConditions" id="paymentTotalPromise"
                      formControlName="paymentConditions" value="TotalPromessa">
                    <label class="form-check-label" for="paymentTotalPromise">
                      O total da remuneração aquando da celebração do contrato-promessa, se o
                      sinal for igual ou superior a 10%. Na situação em que o valor entregue a
                      título de sinal for inferior a 10% do total do valor da venda, a remuneração
                      será liquidada aquando da escritura pública.
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="paymentConditions" id="paymentPartial"
                      formControlName="paymentConditions" value="Parcial">
                    <label class="form-check-label" for="paymentPartial">
                      <input type="text" mask="separator" suffix="%" class="form-control d-inline-block"
                        style="width: 60px;" id="percentPromise" formControlName="percentPromise" name="percentPromise"
                        placeholder="%">
                      após a celebração do contrato-promessa e o remanescente de
                      <input type="text" mask="separator" suffix="%" class="form-control d-inline-block"
                        style="width: 60px;" id="percentDeed" formControlName="percentDeed" name="percentDeed"
                        placeholder="%">
                      na celebração da escritura ou conclusão do negócio.
                    </label>
                  </div>
                </li>
                <li>
                  O direito à remuneração não é afastado pelo exercício do direito legal de
                  preferência, sobre o imóvel.
                </li>
              </ol>
            </div>
          </div>
        </div>

        <!-- Cláusula 6ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula6" aria-expanded="false" aria-controls="collapseClausula6">
              Cláusula 6ª - Obtenção de Documentos
            </button>
          </h2>

          <div id="collapseClausula6" class="accordion-collapse collapse" aria-labelledby="headingClausula6"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <ol>
                <li>
                  No âmbito do presente contrato a Mediadora, na qualidade de mandatária sem
                  representação, obriga-se a prestar os serviços conducentes à obtenção da
                  documentação necessária à concretização do(os) negócio(os) visado(os) pela mediação.
                </li>
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="documentsRemuneration"
                      id="documentsRemunerationA" formControlName="documentsRemuneration" value="A">
                    <label class="form-check-label" for="documentsRemunerationA">
                      Pela prestação dos serviços previstos no número anterior, o Segundo
                      Contratante pagará a quantia de
                      <input type="text" class="form-control d-inline-block" style="width: 120px;" id="documentsValue"
                        formControlName="documentsValue" name="documentsValue" placeholder="€">
                      (<input type="text" class="form-control d-inline-block" style="width: 200px;"
                        id="documentsValueWritten" formControlName="documentsValueWritten" name="documentsValueWritten"
                        placeholder="Valor por extenso">)
                      acrescida de IVA à taxa legal em vigor.
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="documentsRemuneration"
                      id="documentsRemunerationB" formControlName="documentsRemuneration" value="B">
                    <label class="form-check-label" for="documentsRemunerationB">
                      A remuneração pelos serviços referidos no número anterior considera-se
                      incluída no montante acordado na cláusula 5ª e só será devida nos termos aí
                      descritos.
                    </label>
                  </div>
                </li>
                <li>
                  Sem prejuízo do disposto no nº 2, a Mediadora mantém sempre o direito ao reembolso
                  das despesas efetuadas com a obtenção de documentação.
                </li>
              </ol>
              <div class="mt-2">
                <small>
                  (Esta cláusula é facultativa e só deverá ser preenchida se as partes assim o
                  pretenderem e acordarem)
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Cláusula 7ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula7" aria-expanded="false" aria-controls="collapseClausula7">
              Cláusula 7ª - Garantias da Atividade de Mediação
            </button>
          </h2>
          <div id="collapseClausula7" class="accordion-collapse collapse" aria-labelledby="headingClausula7"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              Para garantia da responsabilidade emergente da sua atividade profissional, a Mediadora
              celebrou um contrato de seguro obrigatório de responsabilidade civil no valor de <input type="text"
                class="form-control d-inline-block" style="width: 120px;" id="insurance" formControlName="insurance"
                name="insurance" placeholder="€">,
              apólice nº <input type="text" class="form-control d-inline-block" style="width: 120px;" id="policy"
                formControlName="policy" name="policy"> através da seguradora <input type="text"
                class="form-control d-inline-block" style="width: 120px;" id="insurer" formControlName="insurer"
                name="insurer">
            </div>
          </div>
        </div>

        <!-- Cláusula 8ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula8" aria-expanded="false" aria-controls="collapseClausula8">
              Cláusula 8ª - Prazo de Duração do Contrato
            </button>
          </h2>
          <div id="collapseClausula8" class="accordion-collapse collapse" aria-labelledby="headingClausula8"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              O presente contrato tem uma validade de
              <input type="text" class="form-control d-inline-block" style="width: 120px;" id="contractDuration"
                formControlName="contractDuration" name="contractDuration" placeholder="meses" mask="separator"
                suffix=" meses">
              contados a partir da data da sua celebração, renovando-se automaticamente por iguais e
              sucessivos períodos, caso não seja denunciado por qualquer das partes contratantes através
              de carta registada com aviso de receção ou outro meio equivalente, com a antecedência mínima
              de
              <input type="text" class="form-control d-inline-block" style="width: 80px;" id="terminationNotice"
                formControlName="terminationNotice" name="terminationNotice" placeholder="dias">
              em relação ao seu termo.
            </div>
          </div>
        </div>

        <!-- Cláusula 9ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula9" aria-expanded="false" aria-controls="collapseClausula9">
              Cláusula 9ª - Dever de Colaboração
            </button>
          </h2>
          <div id="collapseClausula9" class="accordion-collapse collapse" aria-labelledby="headingClausula9"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <ol>
                <li>
                  O Segundo Contratante colaborará com a Mediadora na entrega de todos os elementos
                  julgados necessários e úteis no prazo de
                  <input type="text" class="form-control d-inline-block" style="width: 80px;" id="collaborationDeadline"
                    formControlName="collaborationDeadline" name="collaborationDeadline" placeholder="dias">
                  a contar da data de assinatura do presente contrato.
                </li>
                <li>
                  O segundo Contratante declara e garante que, no âmbito das disposições legais
                  aplicáveis de natureza preventiva e repressiva de combate ao branqueamento de
                  capitais e ao financiamento do terrorismo, e em relação a todos os atos e operações
                  abrangidas pelo presente contrato, se obriga a cooperar na disponibilização de
                  informação relevante à Mediadora, designadamente sobre a identidade das partes
                  contratantes, do objeto do negócio imobiliário e dos meios de pagamento das
                  transações imobiliárias.
                </li>
                <li>
                  O Segundo Contratante obriga-se ainda a cumprir todas as disposições legais e
                  regulamentares decorrentes do Sistema de Certificação Energética que se encontram
                  previstas no Decreto-Lei n.º 118/2013, de 20 de agosto, ou seja, a obrigação de
                  providenciar, nos termos e prazos devidos, pela emissão do respetivo Certificado
                  Energético em relação ao imóvel objeto do presente contrato (se aplicável).
                </li>
                <li>
                  O Segundo Contratante obriga-se, também, a dar cumprimento às regras referentes à
                  Ficha Técnica da Habitação, nos termos do disposto no Decreto-Lei n.º 68/2004, de 25
                  de março, nos termos e prazos devidos (se aplicável).
                </li>
              </ol>
            </div>
          </div>
        </div>

        <!-- Accordion Item: Cláusula 10ª - Angariador Imobiliário -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula10" aria-expanded="false" aria-controls="collapseClausula10" [ngClass]="{
                                'text-danger': mediationContractForm.get('agentName')?.invalid
                            }">
              Cláusula 10ª - Angariador Imobiliário
              <span *ngIf="mediationContractForm.get('agentName')?.invalid" class="badge bg-danger ms-2">Campos
                Obrigatórios</span>
            </button>
          </h2>
          <div id="collapseClausula10" class="accordion-collapse collapse" aria-labelledby="headingClausula10"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              O/A
              <input type="text" class="form-control d-inline-block" style="width: 300px;" id="agentName"
                formControlName="agentName" name="agentName" placeholder="Nome do angariador" required
                [ngClass]="{'is-invalid': mediationContractForm.get('agentName')?.invalid}">
              <!-- <div *ngIf="mediationContractForm.get('agentName')?.invalid"
                                class="invalid-feedback d-block">
                                Campo obrigatório.
                            </div> -->
              , contribuinte fiscal nº
              <input type="text" class="form-control d-inline-block" style="width: 180px;"
                id="agentFiscalIdentification" formControlName="agentFiscalIdentification"
                name="agentFiscalIdentification" placeholder="NIF">
              , angariador imobiliário da Mediadora, colaborou na preparação do presente contrato.
            </div>
          </div>
        </div>

        <!-- Cláusula 11ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula11">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula11" aria-expanded="false" aria-controls="collapseClausula11">
              Cláusula 11ª - Foro Competente
            </button>
          </h2>
          <div id="collapseClausula11" class="accordion-collapse collapse" aria-labelledby="headingClausula11"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              Para dirimir quaisquer litígios emergentes da execução do presente contrato, as partes
              acordam entre si estabelecer como competente o foro da comarca de
              <input type="text" class="form-control d-inline-block" style="width: 250px;" id="jurisdiction"
                formControlName="jurisdiction" name="jurisdiction" placeholder="Comarca">
              com expressa renúncia a qualquer outro.
            </div>
          </div>
        </div>

        <!-- Cláusula 12ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula12" aria-expanded="false" aria-controls="collapseClausula12">
              Cláusula 12ª - Competência para dirimir litígios de consumo
            </button>
          </h2>
          <div id="collapseClausula12" class="accordion-collapse collapse" aria-labelledby="headingClausula12"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              Em caso de litígio de consumo, definido nos termos do disposto na Lei n.º 144/2015, de 8 de
              setembro, o consumidor pode recorrer ao <input type="text" class="form-control d-inline-block"
                style="width: 250px;" id="disputeCenter" formControlName="disputeCenter" name="disputeCenter"
                placeholder="Centro de Litígios">
            </div>
          </div>
        </div>

        <!-- Cláusula 13ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula13" aria-expanded="false" aria-controls="collapseClausula13">
              Cláusula 13ª - Tratamento de Dados
            </button>
          </h2>
          <div id="collapseClausula13" class="accordion-collapse collapse" aria-labelledby="headingClausula13"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              <ol>
                <li>
                  Os dados pessoais constantes neste contrato são processados informaticamente pela
                  empresa de mediação imobiliária na sua base de dados de clientes.
                </li>
                <li>
                  O Segundo Contratante, titular dos dados
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="dataAuthorization" id="authorizeData"
                      formControlName="dataAuthorization" [value]="true">
                    <label class="form-check-label" for="authorizeData">autoriza</label>
                  </div>
                  /
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="dataAuthorization" id="notAuthorizeData"
                      formControlName="dataAuthorization" [value]="false">
                    <label class="form-check-label" for="notAuthorizeData">não autoriza</label>
                  </div>
                  a cedência dos respetivos dados pessoais à {{entityData?.name}}.
                  (a preencher pelo Segundo Contratante).
                </li>
                <li>
                  Os dados serão utilizados exclusivamente para controlo de qualidade de prestação de
                  serviços, divulgação e oferta de Serviços.
                </li>
              </ol>
            </div>
          </div>
        </div>

        <!-- Cláusula 14ª -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingClausula14">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseClausula14" aria-expanded="false" aria-controls="collapseClausula14">
              Cláusula 14ª - Limites aos pagamentos em numerário
            </button>
          </h2>
          <div id="collapseClausula14" class="accordion-collapse collapse" aria-labelledby="headingClausula14"
            data-bs-parent="#mediationContractAccordion">
            <div class="accordion-body">
              Os intervenientes no presente contrato de mediação imobiliária abstêm-se de celebrar ou de
              algum modo participar em quaisquer negócios de que resulte a violação dos limites à
              utilização de numerário previsto no artigo 63.º-E, da Lei Geral Tributária, aprovada pelo
              Decreto-Lei n.º 398/98, de 17 de dezembro, aditado pela Lei n.º 92/2017, de 22 de agosto.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="submit" (click)="submitContract()" class="btn btn-primary"
      [attr.disabled]="spinnerLoading ? true : null">
      <span *ngIf="spinnerLoading" class="spinner-border spinner-border-sm me-2" role="status"
        aria-hidden="true"></span>
      {{ 't-deal-actions.t-generate-document' | translate }}
    </button>

    <button type="button" [attr.disabled]="spinnerLoading ? true : null" (click)="modal.dismiss()"
      class="btn btn-secondary" data-bs-dismiss="modal"> {{ 't-general.t-btn-close' | translate }}
    </button>
  </div>
</ng-template>

<div *ngIf="generateContract" id="mediation-contract">
  <div class="mediation-header mb-3">
    <div class="logo">
      <img class="logo" src="{{entityData?.image ? logoPath + entityData?.image : ''}}" alt="Logo">
    </div>
    <div class="d-flex flex-column align-items-center">
      <h5>Contrato de Mediação Imobiliária Nº {{ mediationContractForm.value.contractNumber }}</h5>
      <div>(Nos termos da Lei nº 15/2013 de 08 de fevereiro)</div>
      <h5 class="fs-14 mt-2">COMPRA / ARRENDAMENTO / TRESPASSE / OUTROS</h5>
    </div>
  </div>
  <p class="avoid-page-break">
    Entre<br> <strong *ngIf="mediationContractForm.value.entityName else emptyLine">{{
      mediationContractForm.value.entityName }}</strong>, com sede social na <strong
      *ngIf="mediationContractForm.value.entityAddress else emptyLine">{{
      mediationContractForm.value.entityAddress }}</strong>, com o capital social de <strong
      *ngIf="mediationContractForm.value.entityCapital else emptyLine">{{
      mediationContractForm.value.entityCapital }}</strong> Euros, e com o NIPC n.º <strong
      *ngIf="mediationContractForm.value.entityFiscalIdentification else emptyLine">{{
      mediationContractForm.value.entityFiscalIdentification }}</strong>, matriculada na Conservatória do Registo
    Comercial de
    <strong *ngIf="mediationContractForm.value.conservatory else emptyLine">{{
      mediationContractForm.value.conservatory }}</strong> sob o nº <strong
      *ngIf="mediationContractForm.value.conservatoryNumber else emptyLine">{{
      mediationContractForm.value.conservatoryNumber }}</strong>, detentora da licença AMI nº <strong
      *ngIf="mediationContractForm.value.licenseImo else emptyLine">{{
      mediationContractForm.value.licenseImo }}</strong>, emitida pelo Instituto dos Mercados Públicos, do
    Imobiliário e
    da Construção I.P. (IMPIC, I.P.), adiante designada como <strong>Mediadora</strong>,
  </p>
  <p class="avoid-page-break">
    E <br> <strong *ngIf="mediationContractForm.value.licenseImo else emptyLine">{{
      mediationContractForm.value.ownerName }}</strong>, <span
      *ngIf="mediationContractForm.value.maritalStatus else emptyLine">{{
      't-mediation.t-'+mediationContractForm.value.maritalStatus.toLowerCase() | translate }}</span><ng-container
      *ngIf="mediationContractForm.value.propertyRegime">
      sob o regime de bens <strong>{{
        't-mediation.t-'+mediationContractForm.value.propertyRegime.toLowerCase() | translate
        }}</strong></ng-container>
    <ng-container *ngIf="mediationContractForm.value.spouse">
      , com <strong>{{ mediationContractForm.value.spouse }}</strong>
    </ng-container>
    , residente(s) na <strong *ngIf="mediationContractForm.value.address else emptyLine">{{
      mediationContractForm.value.address }}</strong> em <strong
      *ngIf="mediationContractForm.value.city else emptyLine">{{
      mediationContractForm.value.city }}</strong>, portador(es) do(s) C.C./B.I. nºs <strong
      *ngIf="mediationContractForm.value.ownerIdentification else emptyLine">{{
      mediationContractForm.value.ownerIdentification }}</strong><ng-container
      *ngIf="mediationContractForm.value.spouse"> e <strong
        *ngIf="mediationContractForm.value.ownerIdentification2 else emptyLine">{{
        mediationContractForm.value.ownerIdentification2 }}</strong></ng-container> e
    contribuinte(s) fiscal(is) nºs <strong
      *ngIf="mediationContractForm.value.ownerFiscalIdentification else emptyLine">{{
      mediationContractForm.value.ownerFiscalIdentification }}</strong> <ng-container
      *ngIf="mediationContractForm.value.spouse"> e
      <strong *ngIf="mediationContractForm.value.ownerFiscalIdentification2 else emptyLine">{{
        mediationContractForm.value.ownerFiscalIdentification2 }}</strong></ng-container>, com o contacto
    telefónico <strong *ngIf="mediationContractForm.value.phone else emptyLine">{{
      mediationContractForm.value.phone }}</strong> e endereço electrónico <strong
      *ngIf="mediationContractForm.value.email else emptyLine">{{
      mediationContractForm.value.email }}</strong>, aqui representada pelo seu sócio gerente / administrador /
    procurador / gestor de negócios com poderes para o ato, com domicílio profissional na sede da sua representada,
    adiante designado(s) como Segundo(s) Contratante(s) na qualidade de <strong
      *ngIf="mediationContractForm.value.ownerRole else emptyLine">{{
      't-mediation.t-'+mediationContractForm.value.ownerRole?.toLowerCase() | translate
      }}</strong>, é celebrado o presente Contrato de Mediação Imobiliária que se rege pelas seguintes cláusulas:
  </p>

  <div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 1ª - Identificação do Imóvel:</h6>
      O Segundo Contratante é proprietário e legítimo possuidor da fração autónoma/prédio
      (rústico/urbano)/estabelecimento comercial, destinado(a) a <strong
        *ngIf="mediationContractForm.value.propertyType else emptyLine">{{
        mediationContractForm.value.propertyType }}</strong>, sendo constituído por <strong
        *ngIf="mediationContractForm.value.divisions else emptyLine">{{ mediationContractForm.value.divisions
        }}</strong> divisões, com uma área total de <strong *ngIf="mediationContractForm.value.area else emptyLine">{{
        mediationContractForm.value.area }}</strong>
      m², sito na <strong *ngIf="mediationContractForm.value.propertyAddress else emptyLine">{{
        mediationContractForm.value.propertyAddress }}</strong>, em <strong
        *ngIf="mediationContractForm.value.propertyCity else emptyLine">{{
        mediationContractForm.value.propertyCity }}</strong>, <strong
        *ngIf="mediationContractForm.value.parish else emptyLine">{{ mediationContractForm.value.parish
        }}</strong>, <strong *ngIf="mediationContractForm.value.county else emptyLine">{{
        mediationContractForm.value.county }}</strong>, descrito na Conservatória do Registo Predial de <strong
        *ngIf="mediationContractForm.value.registryOffice else emptyLineLg">{{
        mediationContractForm.value.registryOffice }}</strong>, sob a ficha nº <strong
        *ngIf="mediationContractForm.value.registryNumber else emptyLine">{{
        mediationContractForm.value.registryNumber }}</strong>, com a licença de construção/utilização nº
      <strong *ngIf="mediationContractForm.value.constructionLicense else emptyLine">{{
        mediationContractForm.value.constructionLicense }}</strong> emitida pela Câmara Municipal de <strong
        *ngIf="mediationContractForm.value.cityCouncil else emptyLineLg">{{
        mediationContractForm.value.cityCouncil }}</strong> em <strong
        *ngIf="mediationContractForm.value.issueDate else emptyLine">{{ mediationContractForm.value.issueDate |
        date:'dd/MM/yyyy' }}</strong> e inscrito na matriz predial (urbana/rústica) com o artigo nº <strong
        *ngIf="mediationContractForm.value.matrixArticle else emptyLine">{{
        mediationContractForm.value.matrixArticle }}</strong> da freguesia de <strong
        *ngIf="mediationContractForm.value.matrixParish else emptyLineLg">{{
        mediationContractForm.value.matrixParish }}</strong> /omisso na matriz <strong
        *ngIf="mediationContractForm.value.matrixOmitted else emptyLine">{{
        mediationContractForm.value.matrixOmitted }}</strong>.
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 2ª - Identificação do Negócio:</h6>
      1 - A Mediadora obriga-se a diligenciar no sentido de conseguir interessado na:
      <span>
        <input type="checkbox" [checked]="mediationContractForm.value.businessBuy" disabled> Compra
      </span>
      <span>
        <input type="checkbox" [checked]="mediationContractForm.value.businessTransfer" disabled> Trespasse
      </span>
      <span>
        <input type="checkbox" [checked]="mediationContractForm.value.businessRent" disabled> Arrendamento
      </span>
      <span>
        <input type="checkbox" [checked]="mediationContractForm.value.businessOther" disabled> Outro
        <span *ngIf="mediationContractForm.value.businessOther && mediationContractForm.value.businessOtherDescription">
          ({{ mediationContractForm.value.businessOtherDescription }})
        </span>
      </span>
      pelo preço de <strong *ngIf="mediationContractForm.value.businessPrice else emptyLine">{{
        mediationContractForm.value.businessPrice }}</strong> Euros (<strong
        *ngIf="mediationContractForm.value.businessPriceWritten else emptyLineLg">{{
        mediationContractForm.value.businessPriceWritten }}</strong>), desenvolvendo para o efeito ações de
      promoção e recolha de informações sobre os negócios pretendidos e características dos respetivos
      imóveis.<br>
      2 - Qualquer alteração ao preço fixado no número anterior deverá ser comunicada de imediato e por escrito à
      Mediadora.
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 3ª - Ónus e Encargos:</h6>
      <span *ngIf="!mediationContractForm.value.onus">O imóvel encontra-se livre de quaisquer ónus ou
        encargos.</span>
      <span *ngIf="mediationContractForm.value.onus">
        O Segundo Contratante declara que sobre o imóvel recaem os seguintes ónus e encargos (hipotecas e
        penhoras): <strong *ngIf="mediationContractForm.value.onusDescription else emptyLine">{{
          mediationContractForm.value.onusDescription }}</strong>, pelo valor de <strong
          *ngIf="mediationContractForm.value.onusValue else emptyLine">{{
          mediationContractForm.value.onusValue }}</strong> Euros.
      </span>
    </div>
    <div class="my-3">
      <h6 class="text-black text-center avoid-page-break">Cláusula 4ª - Regime de Contratação:</h6>
      1 - O Segundo Contratante contrata a Mediadora em regime de <strong
        *ngIf="mediationContractForm.value.contractRegime !== null else emptyLine">{{
        mediationContractForm.value.contractRegime ? 'Exclusividade' : 'Não Exclusividade' }}</strong>.<br>
      <span class="avoid-page-break"> 2 - Nos termos da legislação aplicável, quando o contrato é celebrado em
        regime de exclusividade só a
        Mediadora contratada tem o direito de promover
        o negócio objeto do contrato de mediação durante o respetivo período de vigência, ficando o Segundo
        Contratante obrigado a pagar a comissão acordada
        caso viole a obrigação de exclusividade.</span>
    </div>
    <div class="my-3">
      <h6 class="text-black text-center avoid-page-break">Cláusula 5ª - Remuneração:</h6>
      <span class="avoid-page-break">1 - A remuneração será devida se a Mediadora conseguir interessado que
        concretize o negócio visado
        pelo presente contrato e também, nos casos em
        que o contrato tenha sido celebrado em regime de exclusividade, o negócio não se concretize por causa
        imputável ao cliente. </span><br>

      <span class="avoid-page-break">
        2 - O Segundo Contratante obriga-se a pagar à Mediadora a título de remuneração: <br>
        <input type="radio" class="me-1" [checked]="mediationContractForm.value.remunerationType === 'PercentualMinimo'"
          disabled>
        A quantia de <strong *ngIf="mediationContractForm.value.percentMin else emptyLine">{{
          mediationContractForm.value.percentMin }}</strong>% calculada sobre o preço pelo
        qual o negócio é efetivamente concretizado, com o valor mínimo de <strong
          *ngIf="mediationContractForm.value.minValue else emptyLine">{{ mediationContractForm.value.minValue
          }}</strong> €, acrescido de IVA à taxa legal de <strong
          *ngIf="mediationContractForm.value.taxMin else emptyLine">{{ mediationContractForm.value.taxMin
          }}</strong>%.
      </span>
      <br>
      <span class="avoid-page-break">
        <input type="radio" class="me-1" [checked]="mediationContractForm.value.remunerationType === 'Percentual'"
          disabled>
        A quantia de <strong *ngIf="mediationContractForm.value.percent else emptyLine">{{
          mediationContractForm.value.percent }}</strong>% sobre o preço pelo qual o
        negócio é efetivamente concretizado, acrescido de IVA à taxa legal de <strong
          *ngIf="mediationContractForm.value.tax else emptyLine">{{ mediationContractForm.value.tax
          }}</strong>%.
      </span>
      <br>
      <span class="avoid-page-break">3 – O pagamento da remuneração apenas será efetuado nas seguintes condições:
      </span>
      <br>
      <span class="avoid-page-break">
        <input type="radio" class="me-1" [checked]="mediationContractForm.value.paymentConditions === 'TotalPromessa'"
          disabled>
        O total da remuneração aquando da celebração do contrato-promessa, se o sinal for igual ou superior a
        10%. Na situação em que o valor entregue a título de sinal for inferior a 10% do total do valor da
        venda, a remuneração será liquidada aquando da escritura pública.
      </span>
      <br>
      <span class="avoid-page-break">
        <input type="radio" class="me-1" [checked]="mediationContractForm.value.paymentConditions === 'Parcial'"
          disabled>
        <strong *ngIf="mediationContractForm.value.percentPromise else emptyLine">{{
          mediationContractForm.value.percentPromise }}</strong>% após a celebração do
        contrato-promessa e o remanescente de <strong *ngIf="mediationContractForm.value.percentDeed else emptyLine">{{
          mediationContractForm.value.percentDeed }}</strong>% na
        celebração da escritura ou conclusão do negócio.
      </span>
      <br>
      <span class="avoid-page-break">4 – O direito à remuneração não é afastado pelo exercício do direito legal de
        preferência, sobre o
        imóvel.</span>
    </div>
    <div class="my-3">
      <h6 class="text-black text-center avoid-page-break">Cláusula 6ª - Obtenção de Documentos:</h6>
      <span class="avoid-page-break">1 – No âmbito do presente contrato a Mediadora, na qualidade de mandatária
        sem representação,
        obriga-se a prestar os serviços conducentes à
        obtenção da documentação necessária à concretização do(os) negócio(os) visado(os) pela mediação. </span>
      <br>
      <span class="avoid-page-break">
        <input type="radio" class="me-1" [checked]="mediationContractForm.value.documentsRemuneration === 'A'" disabled>
        2 – a) Pela prestação dos serviços, o Segundo Contratante pagará a quantia de <strong
          *ngIf="mediationContractForm.value.documentsValue else emptyLine">{{
          mediationContractForm.value.documentsValue }}</strong> € (<strong
          *ngIf="mediationContractForm.value.documentsValueWritten else emptyLineLg">{{
          mediationContractForm.value.documentsValueWritten }}</strong>), acrescida de IVA à taxa legal em
        vigor.
      </span>
      <br>
      OU
      <br>
      <span class="avoid-page-break">
        <input type="radio" class="me-1" [checked]="mediationContractForm.value.documentsRemuneration === 'B'" disabled>
        b) A remuneração pelos serviços considera-se incluída no montante acordado na cláusula 5ª e só será
        devida
        nos termos aí descritos.
      </span>
      <br>
      <span class="avoid-page-break">
        3 – Sem prejuízo do disposto no nº 2, a Mediadora mantém sempre o direito ao reembolso das despesas
        efetuadas com a obtenção de documentação.
      </span>
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 7ª - Garantias da Atividade de Mediação:</h6>
      Para garantia da responsabilidade emergente da sua atividade profissional, a Mediadora celebrou um contrato
      de seguro obrigatório de responsabilidade civil no valor de <strong
        *ngIf="mediationContractForm.value.insurance else emptyLine">{{ mediationContractForm.value.insurance
        }}</strong> €, apólice nº <strong *ngIf="mediationContractForm.value.policy else emptyLine">{{
        mediationContractForm.value.policy }}</strong> através da
      seguradora <strong *ngIf="mediationContractForm.value.insurer else emptyLineLg">{{
        mediationContractForm.value.insurer }}</strong>.
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 8ª - Prazo de Duração do Contrato:</h6>
      O presente contrato tem uma validade de <strong
        *ngIf="mediationContractForm.value.contractDuration else emptyLine">{{
        mediationContractForm.value.contractDuration }} meses </strong>
      contados a partir da data da sua celebração, renovando-se automaticamente por iguais e sucessivos períodos,
      caso não seja denunciado por qualquer das partes contratantes através de carta registada com aviso de
      receção ou outro meio equivalente, com a antecedência mínima de <strong
        *ngIf="mediationContractForm.value.terminationNotice else emptyLine">{{
        mediationContractForm.value.terminationNotice }}</strong> dias em relação ao seu termo.
    </div>
    <div class="my-3">
      <h6 class="text-black text-center avoid-page-break">Cláusula 9ª - Dever de Colaboração:</h6>
      <span class="avoid-page-break">1 - O Segundo Contratante colaborará com a Mediadora na entrega de todos os
        elementos julgados necessários e
        úteis no prazo de <strong *ngIf="mediationContractForm.value.collaborationDeadline else emptyLine">{{
          mediationContractForm.value.collaborationDeadline }}</strong> dias a contar
        da
        data de assinatura do presente contrato. (Restante texto conforme cláusula original)</span>
      <br>
      <span class="avoid-page-break">2 – O segundo Contratante declara e garante que, no âmbito das disposições
        legais aplicáveis de natureza
        preventiva e repressiva de combate ao
        branqueamento de capitais e ao financiamento do terrorismo, e em relação a todos os atos e operações
        abrangidas pelo presente contrato, se obriga a
        cooperar na disponibilização de informação relevante à Mediadora, designadamente sobre a identidade das
        partes contratantes, do objeto do negócio
        imobiliário e dos meios de pagamento das transações imobiliárias.</span>
      <br>
      <span class="avoid-page-break">3 – O Segundo Contratante obriga-se ainda a cumprir todas as disposições
        legais e regulamentares decorrentes
        do Sistema de Certificação Energética
        que se encontram previstas no Decreto-Lei n.º 118/2013, de 20 de agosto, ou seja, a obrigação de
        providenciar, nos termos e prazos devidos, pela
        emissão do respetivo Certificado Energético em relação ao imóvel objeto do presente contrato (se
        aplicável).</span>
      <br>
      <span class="avoid-page-break">4 – O Segundo Contratante obriga-se, também, a dar cumprimento às regras
        referentes à Ficha Técnica da
        Habitação, nos termos do disposto no Decreto
        Lei n.º 68/2004, de 25 de março, nos termos e prazos devidos (se aplicável).</span>
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 10ª - Angariador Imobiliário:</h6>
      O/A <strong *ngIf="mediationContractForm.value.agentName else emptyLine">{{
        mediationContractForm.value.agentName }}</strong>, contribuinte fiscal nº <strong
        *ngIf="mediationContractForm.value.agentFiscalIdentification else emptyLine">{{
        mediationContractForm.value.agentFiscalIdentification }}</strong>, angariador imobiliário da Mediadora,
      colaborou na
      preparação do presente contrato.
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 11ª - Foro Competente:</h6>
      Para dirimir quaisquer litígios emergentes da execução do presente contrato, as partes acordam entre si
      estabelecer como competente o foro da comarca de <strong
        *ngIf="mediationContractForm.value.jurisdiction else emptyLineLg">{{
        mediationContractForm.value.jurisdiction }}</strong> com expressa renúncia a qualquer outro.
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 12ª - Competência para dirimir litígios de consumo:</h6>
      Em caso de litígio de consumo, o consumidor pode recorrer ao <strong
        *ngIf="mediationContractForm.value.disputeCenter else emptyLineLg">{{
        mediationContractForm.value.disputeCenter }}</strong>.
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 13ª - Tratamento de Dados:</h6>
      <span>1 – Os dados pessoais constantes neste contrato são processados informaticamente pela empresa de
        mediação imobiliária na sua base de dados de
        clientes. </span>
      <br>
      <span>2 – O Segundo Contratante, titular dos dados
        <input type="radio" class="me-1" [checked]="mediationContractForm.value.dataAuthorization" disabled>
        autoriza
      </span>
      /
      <span>
        <input type="radio" class="me-1" [checked]="!mediationContractForm.value.dataAuthorization" disabled>
        não autoriza
      </span>
      a cedência dos respetivos dados pessoais à
      <strong *ngIf="entityData?.name else emptyLine">{{ entityData?.name }}</strong>.
    </div>
    <div class="my-3 avoid-page-break">
      <h6 class="text-black text-center">Cláusula 14ª - Limites aos pagamentos em numerário:</h6>
      Os intervenientes no presente contrato de mediação imobiliária abstêm-se de celebrar ou de algum modo
      participar em quaisquer negócios de que resulte a violação dos limites à utilização de numerário previsto no
      artigo 63.º-E, da Lei Geral Tributária.
    </div>
  </div>
  <div class="mt-4">
    Depois de lido e ratificado, as partes comprometem-se a cumprir este contrato segundo os ditames da boa fé, e
    vão assinar.<br>
    Feito em duplicado, destinando-se um exemplar a cada uma das partes intervenientes.
    <br><br>
    <div class="d-flex align-items-center">
      <div class="me-1" style="border-bottom: 1px solid #000; width: 30%"></div><span class="break-normal me-1"> ,
      </span>
      <div class="me-1" style="border-bottom: 1px solid #000; width: 10%"></div><span class="break-normal me-1">
        de </span>
      <div class="me-1" style="border-bottom: 1px solid #000; width: 25%"></div><span class="break-normal me-1">
        de </span>
      <div class="me-1" style="border-bottom: 1px solid #000; width: 10%"></div><span class="break-normal me-1">
        .</span>
    </div>
    <br><br>
    <div class="row">
      <div class="col text-center">
        <div style="width: 100%;">
          <strong>A MEDIADORA</strong><br>
          <div style="border-bottom: 1px solid #000; width: 100%; height: 50px"></div>
        </div>
      </div>
      <div class="col text-center">
        <div style="width: 100%;">
          <strong>O SEGUNDO CONTRATANTE</strong><br>
          <div style="border-bottom: 1px solid #000; width: 100%; height: 50px"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyLine>
  <span style="border-bottom: 1px solid #000; display: inline-block; width: 120px;">&nbsp;</span>
</ng-template>

<ng-template #emptyLineLg>
  <span style="border-bottom: 1px solid #000; display: inline-block; width: 280px;">&nbsp;</span>
</ng-template>